import React, { Component, createRef } from 'react';
import { ToastContainer } from "react-toastify";
import Loader from "../../../utils/Loader";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../utils/withRouter";
import Pagination from "../../../utils/pagination";
import { fill_action } from '../../../actions/fillCombo_action'
import { connect } from "react-redux";
import { downloadReport, toastError, toastSuccess, countryActionId, RecommendationTypeActionId, visitorRegistrationLink } from "../../../utils/constants"
import { Link } from "react-router-dom";
import Modal from "react-modal";
import DelegateTopMenu from "../../../common_components/delegate_module_topmenu";
import DelegateDrawer from "../../../common_components/delegate_module_drawer";
import VisitorTopMenu from "../../../common_components/visitor_module_topmenu";
import VisitorDrawer from "../../../common_components/visitor_module_drawer";
import VisitorHeader2 from "../../../common_components/visitor_module_header2";
import { getDrawerDetails_action } from "../../../actions/exhibitor_module_actions/exhibitor_dashboard_action/exhibitor_dashboard_action"
import { getVisitorDashboard_action, getVisitorRegistrationCredentials_action, getVisitorBadge_action } from "../../../actions/visitor_module_action/visitor_dashboard_action/visitor_dashboard_action"
import { getCoordinatorDelegate_action, getDelegateDashboard_action, getDelegateRegistrationCredentials_action } from "../../../actions/delegate_module_action/delegate_dashboard_action/delegate_dashboard_action"
import { getRecommendation_action, getAllRecommendation_action, getRecommendationB2bDetails_action } from "../../../actions/delegate_module_action/delegate_dashboard_action/recommendation_action"
import { getB2bScheduleList_action, removeB2bMeeting_action, updateB2bStatus_action, addB2bPersonalNotes_action } from "../../../actions/delegate_module_action/my_schedule_action/my_schedule_action"
import moment from "moment";

class MySchedule extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        //States
        this.state = {
            isLoading: false,
            isOpen: false,

            isCoordinator: false,
            CoordinatorID: '',
            delegateList: [],
            selectedVisitorID: '',
            isVisitorSelect: false,
            coordinatorFN: '',
            coordinatorLN: '',
            coordinatorDelegateRegistrationID: '',
            ArrangementType: '',
            RegistrationID: '',
            ReferenceID: '',
            PersonalNotes: '',

            scheduleList: [],
            status: null,
            b2bID: '',
            remark: '',
            isOpenNote: false,
        }
        this.printAreaRef = React.createRef();
        // this.getDrawerDetails = this.getDrawerDetails.bind(this)
        // this.getDrawerDetails = this.getDrawerDetails.bind(this)
        // this.getRecommendation = this.getRecommendation.bind(this)
        this.toggleModel = this.toggleModel.bind(this)
        this.onStatusUpdate = this.onStatusUpdate.bind(this)
        // this.onUpdate = this.onUpdate.bind(this)
        this.getB2bMeetinList = this.getB2bMeetinList.bind(this)
        this.onMeetingUpdate = this.onMeetingUpdate.bind(this)
    }

    componentDidMount() {
        this.getB2bMeetinList()
    }

    getB2bMeetinList() {
        const { typeID, typeList, productRecommendation, companyRecommendation, countryRecommendation, recommendationList } = this.state
        this.setState({ isLoading: true })
        var id = ''
        var type = sessionStorage.getItem('typeID')
        if (type == 1) {
            id = sessionStorage.getItem('ExhRegistrationIDSS')
        } else if (type == 2) {
            id = false ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).DelegateRegistrationID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID
        } else if (type == 3) {
            id = false ? JSON.parse(sessionStorage.getItem('SelectedVisitorDataSS')).ExhVisitorID : JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
        }
        return new Promise((resolve => {
            this.props.getB2bScheduleList_action(id, type)
                .then((data) => {
                    this.setState({ RegistrationID: id })
                    if (data.error != 1) {
                        console.log(data.data)
                        var b2bList = data.data[1] != undefined ? data.data[1].length > 0 ? data.data[1] : [] : data.data[0].length > 0 ? data.data[0] : []
                        for (var i = 0; i < b2bList.length; i++) {
                            if (b2bList[i].ArrangementType == "B2B Meeting") {
                                var productArr = b2bList[i].ChapterNames != null ? b2bList[i].ChapterNames.split(',') : []

                                // const finalproductArr = [];
                                // for (var j = 0; j < productArr.length; j++) {
                                //     var current = productArr[j];
                                //     current = current.trim()
                                //     if (/^[0-9]$/.test(current.charAt(0))) {
                                //         finalproductArr.push(current);
                                //     } else {
                                //         if (finalproductArr.length > 0) {
                                //             finalproductArr[finalproductArr.length - 1] += ` ${current}`;
                                //         } else {
                                //             finalproductArr.push(current);
                                //         }
                                //     }
                                // }
                                // for (var a = 0; a < finalproductArr.length; a++) {
                                //     finalproductArr[a].trim()
                                //     if (/^\d$/.test(finalproductArr[a][0])) {
                                //         for (var j = 0; j < finalproductArr[a].length; j++) {
                                //             if (finalproductArr[a][j] == ' ') {
                                //                 var str = finalproductArr[a].slice(j)
                                //                 var finalName = str
                                //                 finalproductArr[a] = finalName
                                //                 // console.log("primaryChapterListActionId 121212", i, finalName)
                                //                 break
                                //             }
                                //         }
                                //         // var itemArr = item2.split(' ')
                                //         // item1 = item1
                                //     }
                                // }
                                var countryArr = b2bList[i].CountryName != null ? b2bList[i].CountryName.split(',') : []
                                b2bList[i].products = productArr
                                b2bList[i].country = countryArr
                            }
                        }
                        // var seminarList = data.data[1].length > 0 ? data.data[1] : []
                        var allData = [...b2bList]
                        allData.sort((a, b) => new Date(b.StartTime) - new Date(a.StartTime))
                        allData.sort((a, b) => new Date(b.Date) - new Date(a.Date))
                        console.log(allData)
                        this.setState({ scheduleList: allData })
                        //     var temprecommendationdata = data.data.length > 0 ? data.data : []
                        //     for (var i = 0; i < temprecommendationdata.length; i++) {
                        //         var obj = {}
                        //         obj.CompanyName = temprecommendationdata[i].CompanyName
                        //         obj.PersonName = temprecommendationdata[i].PersonName
                        //         obj.Designation = temprecommendationdata[i].Designation
                        //         obj.TypeID = temprecommendationdata[i].TypeID
                        //         obj.RegistrationID = temprecommendationdata[i].RegistrationID
                        //         var productArr = temprecommendationdata[i].ChapterNames != null ? temprecommendationdata[i].ChapterNames.split(',') : []
                        //         // productArr.length > 0 && productArr.map(item => {
                        //         //     item = item.trim()
                        //         // })
                        //         const finalproductArr = [];
                        //         for (var j = 0; j < productArr.length; j++) {
                        //             var current = productArr[j];
                        //             current = current.trim()
                        //             if (/^[0-9]$/.test(current.charAt(0))) {
                        //                 finalproductArr.push(current);
                        //             } else {
                        //                 if (finalproductArr.length > 0) {
                        //                     finalproductArr[finalproductArr.length - 1] += ` ${current}`;
                        //                 } else {
                        //                     finalproductArr.push(current);
                        //                 }
                        //             }
                        //         }
                        //         var countryArr = temprecommendationdata[i].CountryName != null ? temprecommendationdata[i].CountryName.split(',') : []
                        //         obj.data = { 'country': countryArr, 'products': finalproductArr }
                        //         recommendationdata.push(obj)
                        //     }
                        //     console.log(recommendationdata)
                        //     this.setState({ recommendationList: recommendationdata })
                        this.setState({ isLoading: false })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }

                }).catch((err) => {
                    console.log(err)
                    this.setState({ isLoading: false })
                    toastError(err.message || 'Something went wrong')
                })
        }))
    }


    toggleModel(value, id) {
        const { typeID, isOpen, typeList, b2bID, productRecommendation, status, remark, companyRecommendation, countryRecommendation, recommendationList } = this.state
        if (!isOpen) {
            this.setState({
                status: value, isOpen: !isOpen, b2bID: id
            })
        } else {
            this.setState({
                status: null, isOpen: !isOpen, remark: '', b2bID: ''
            })
        }
    }

    onStatusUpdate() {
        const { typeID, typeList, b2bID, productRecommendation, scheduleList, status, remark, companyRecommendation, countryRecommendation, recommendationList } = this.state
        var statusChangePerms = true
        if (status == 2) {
            var strtTime = ''
            var EndTime = ''
            var Date = ''
            for (var i = 0; i < scheduleList.length; i++) {
                if (scheduleList[i].ArrangementType == 'B2B Meeting') {
                    if (b2bID == scheduleList[i].t_B2BMeetingID) {
                        strtTime = scheduleList[i].StartTime
                        EndTime = scheduleList[i].EndTime
                        Date = scheduleList[i].Date
                    }
                }
            }
            for (var i = 0; i < scheduleList.length; i++) {
                if (scheduleList[i].ArrangementType == 'B2B Meeting') {
                    if (b2bID != scheduleList[i].t_B2BMeetingID) {
                        if (strtTime == scheduleList[i].StartTime && EndTime == scheduleList[i].EndTime && Date == scheduleList[i].Date) {
                            if (scheduleList[i].B2BStatusID == 2) {
                                statusChangePerms = false
                                break
                            }
                        }
                    }
                }
            }
        }
        if (statusChangePerms) {
            this.setState({ isLoading: true })
            this.props.updateB2bStatus_action(b2bID, status, remark)
                .then((data) => {
                    if (data.error != 1) {
                        this.getB2bMeetinList()
                        toastSuccess(status == 2 ? "Approved Successfully" : "Rejected Successfully")
                        this.setState({ isOpen: false })
                    }
                })
        } else {
            this.setState({ isOpen: false })

            toastError("A meeting is already scheduled for same date and time")
        }
    }

    SubmitPersonalNote() {
        const { isLoading, page, countryList, isOpen, remark, status, selectedVisitorID, recommendationList, typeID, productRecommendation, productAll, countryRecommendation, countryAll, companyRecommendation, ArrangementType, ReferenceID, RegistrationID, PersonalNotes, companyAll, allRecommendationList, scheduleList } = this.state
        this.props.addB2bPersonalNotes_action(ArrangementType,
            sessionStorage.getItem('typeID'),
            RegistrationID,
            ReferenceID,
            PersonalNotes)
            .then((data) => {
                if (data.error != 1) {
                    this.getB2bMeetinList()
                    toastSuccess("Submit Successful")
                    this.setState({
                        isOpenNote: false, ArrangementType: '',
                        ReferenceID: '',
                        PersonalNotes: ''
                    })
                }
            })
    }

    onMeetingUpdate(id, type) {
        var Fromid = ''
        var fromtypeID = sessionStorage.getItem('typeID')
        if (fromtypeID == 1) {
            Fromid = sessionStorage.getItem('ExhRegistrationIDSS')
        } else if (fromtypeID == 2) {
            Fromid = false ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).DelegateRegistrationID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID
        } else if (fromtypeID == 3) {
            Fromid = false ? JSON.parse(sessionStorage.getItem('SelectedVisitorDataSS')).ExhVisitorID : JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID
        }
        this.props.navigate('/recommendationBookNow',
            {
                state: {
                    // typeID: this.state.typeID,
                    // fromtypeID: this.state.typeID,
                    fromRegistrationID: Fromid,
                    totypeID: type,
                    toRegistrationID: id,
                    isUpdate: true
                    // designation: Designation,
                    // countryList: countryList,
                    // productList: productList,
                    // company: company,
                }
            }
        )
    }

    removeMeeting() {
        const { b2bID } = this.state
        this.setState({ isLoading: true })
        this.props.removeB2bMeeting_action(b2bID)
            .then((data) => {
                if (data.error != 1) {
                    setTimeout(() => {
                        this.getB2bMeetinList();
                        this.setState({ isLoading: false, isOpen: false })
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false, isOpen: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    handlePrint() {
        window.print()
    }

    render() {
        const { isLoading, page, countryList, isOpen, remark, status, selectedVisitorID, recommendationList, typeID, productRecommendation, productAll, countryRecommendation, countryAll, isOpenNote, companyRecommendation, companyAll, allRecommendationList, scheduleList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {sessionStorage.getItem('RoleIDSS') == 1 ? <HeaderWithLogo /> : (
                    <>
                        {sessionStorage.getItem('typeID') == 1 && <ExhibitorHeader />}
                        {sessionStorage.getItem('typeID') == 2 && <VisitorHeader2 />}
                        {sessionStorage.getItem('typeID') == 3 && <VisitorHeader2 />}
                    </>
                )}

                {sessionStorage.getItem('RoleIDSS') == 1 ? <ExhibitorDrawer /> : (
                    <>
                        {sessionStorage.getItem('typeID') == 1 && <ExhibitorDrawer />}
                        {sessionStorage.getItem('typeID') == 2 && <DelegateDrawer />}
                        {sessionStorage.getItem('typeID') == 3 && <VisitorDrawer />}
                    </>
                )}
                {/*app-content open*/}
                <div className="page">
                    <div className="page-main">
                        <div className={sessionStorage.getItem('RoleIDSS') == 1 ? "main-content with-dr-container mt-5" : "main-content with-dr-container mt-3"} style={sessionStorage.getItem('RoleIDSS') == 1 ? { marginTop: '85px' } : {}}>
                            <div className="">
                                <div className=" width-dr-nav">
                                    <div className="row">
                                        {sessionStorage.getItem('typeID') == 1 && <ExhibitorTopMenu />}
                                        {sessionStorage.getItem('typeID') == 2 && <DelegateTopMenu />}
                                        {sessionStorage.getItem('typeID') == 3 && <VisitorTopMenu />}
                                    </div>
                                </div>
                                <div class="main-content app-content mt-0">
                                    <div className="" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div className="d-flex flex-column flex-md-row mt-2 mx-0 mx-md-3 text-dark legendrow" style={{ fontSize: '13px' }}>
                                            <div className="d-flex align-items-center mb-2 me-4 legendrow1">
                                                <div style={{ width: '20px', height: '20px', backgroundColor: '#c6ffe9', marginRight: '10px', borderRadius: '4px' }}></div>
                                                <span style={{ whiteSpace: 'nowrap' }}>- {true ? 'Conference Session' : 'Seminar'}</span>
                                            </div>
                                            <div className="d-flex align-items-center mb-2 me-4 legendrow1">
                                                <div style={{ width: '20px', height: '20px', backgroundColor: '#3dbca7db', marginRight: '10px', borderRadius: '4px' }}></div>
                                                <span style={{ whiteSpace: 'nowrap' }}>- Interest to meet</span>
                                            </div>
                                            <div className="d-flex align-items-center mb-2 legendrow1">
                                                <div style={{ width: '20px', height: '20px', backgroundColor: '#9ea0a1', marginRight: '10px', borderRadius: '4px' }}></div>
                                                <span style={{ whiteSpace: 'nowrap' }}>- Invitation</span>
                                            </div>
                                        </div>
                                        <div className="p-0 mb-2 text-right text-end mt-4 mx-3">
                                            {scheduleList.length > 0 ? <button
                                                className="btn btn-aqua printbtn"
                                                // disabled={itiPath == '' || itiPath == null}
                                                onClick={() => this.handlePrint()}
                                            >
                                                Print
                                            </button> : null}
                                        </div>
                                    </div>
                                    <div className="container-fluid px-0 px-md-4 py-2">
                                        <div className="row  print-area" ref={this.printAreaRef}>
                                            {/* Top Section for B2B Meetings */}
                                            <div className="col-12">
                                                {scheduleList.filter(item => item.ArrangementType == 'B2B Meeting').map(item => (
                                                    <div className="card mb-4 border p-0" style={{ borderRadius: '12px', backgroundColor: '#f8f9fa', border: '1px solid #ccc', boxShadow: 'none' }}>
                                                        <div className="card-body p-3 text-left pb-1">
                                                            <div className="d-flex justify-content-between align-items-start mb-1">
                                                                <span className="badge rounded-pill" style={{ backgroundColor: '#48bda9', color: 'white', padding: '8px 16px', fontSize: '13px', fontWeight: '500' }}>
                                                                    <i className="fa fa-tags mr-2"></i> Interest to meet
                                                                </span>
                                                                {item.B2BBookedByTypID == sessionStorage.getItem('typeID') ? <button className="btn btn-aqua" onClick={() => this.setState({ isOpen: true, b2bID: item.t_B2BMeetingID })} >
                                                                    Not Interested
                                                                </button> : <></>}
                                                            </div>
                                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <div>
                                                                    <h5 className="mb-2 text-dark text-left">{item.CompanyName}</h5>
                                                                    <p className=" mb-3 text-left" style={{ fontSize: '15px' }}><i className="fa fa-user-o mr-2"></i> {item.PersonName} {item.Designation != null && '|'} {item.Designation}</p>
                                                                </div>
                                                                {sessionStorage.getItem('typeID') == 1 ? <h6 className="fw-semibold mb-2 text-left">{item.B2BBookedByTypID == 2 ? item.accountType : 'Visitor'} {item.B2BBookedByTypID == 2 && item.IsCoordinator ? 'Coordinator' : ''}</h6> : <></>}
                                                            </div>

                                                            <div className="row mb-0 text-left">
                                                                <div className="col-md-4">
                                                                    <p className="text-uppercase mb-1" style={{ fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', color: '#555' }}>{sessionStorage.getItem('typeID') == 1 ? "Purpose of Visit" : "Location"}</p>
                                                                    {sessionStorage.getItem('typeID') == 1 ? <p className="mb-0 font-weight-bold" style={{ fontSize: '15px', color: '#222' }}>
                                                                        {item.PurposeOfVisit ? item.PurposeOfVisit : '-'}
                                                                    </p> : <p className="mb-0 font-weight-bold" style={{ fontSize: '15px', color: '#222' }}>
                                                                        {item.HallName || item.StallName ? `${item.HallName ? 'Hall Name: Hall ' + item.HallName.replace(/hall\s*(name|no\.?|:)?\s*/i, '').trim() : ''}${item.HallName && item.StallName ? ', ' : ''}${item.StallName ? 'Stall No: ' + item.StallName.replace(/stall\s*(name|no\.?|:)?\s*/i, '').trim() : ''}` : '-'}
                                                                    </p>}
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <p className="text-uppercase mb-1" style={{ fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', color: '#555' }}>{sessionStorage.getItem('typeID') == 1 ? 'Industry' : 'Main'} Segment</p>
                                                                    <p className="mb-0 font-weight-bold" style={{ fontSize: '15px', color: '#222' }}>{item.ChapterName != '' && item.ChapterName != null ? item.ChapterName : '-'}</p>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <p className="text-uppercase mb-1" style={{ fontSize: '11px', fontWeight: 'bold', letterSpacing: '1px', color: '#555' }}>Country</p>
                                                                    <p className="mb-0 font-weight-bold" style={{ fontSize: '15px', color: '#222' }}>
                                                                        {item.country.length > 0 ? item.country.join(', ') : '-'}
                                                                    </p>
                                                                </div>
                                                            </div>

                                                            <div className="mb-0 mt-3 text-left">
                                                                <p className="mb-0 fw-semibold" style={{ fontSize: '13px', }}>Products</p>
                                                                <style>{`
                                                                    @media (max-width: 767px) {
                                                                        .mobile-badge-full {
                                                                            width: 100% !important;
                                                                            display: block !important;
                                                                        }
                                                                    }
                                                                `}</style>
                                                                <div className="d-flex flex-wrap">
                                                                    {item.products.length > 0 && item.products.map((element, i) => (
                                                                        <span key={i} className="badge bg-white text-dark border p-2 px-3 mr-2 mb-2 m-1 mobile-badge-full" style={{ fontWeight: 'normal', fontSize: '13px', borderColor: '#d5e9e6', whiteSpace: 'normal', textAlign: 'left', lineHeight: '1.4' }}>{element}</span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="card-footer p-4 pt-0 border-0 text-left pb-2" style={{ backgroundColor: 'transparent', borderTop: '2px solid #d5e9e6 !important' }}>
                                                            <div className="mb-3">
                                                                <div className="d-flex justify-content-between align-items-center mb-1">
                                                                    <label className="text-dark">Personal Notes</label>
                                                                    <button
                                                                        className="btn btn-aqua"
                                                                        title={item.PersonalNotes != null && item.PersonalNotes != '' ? "Update Note" : "Add Note"}
                                                                        onClick={() => this.setState({
                                                                            isOpenNote: true,
                                                                            ReferenceID: item.ReferenceID,
                                                                            ArrangementType: item.ArrangementType,
                                                                            PersonalNotes: item.PersonalNotes != null && item.PersonalNotes != '' ? item.PersonalNotes : ''
                                                                        })}
                                                                    >
                                                                        {item.PersonalNotes != null && item.PersonalNotes != '' ? "Edit Note" : "Add Note"}
                                                                    </button>
                                                                </div>
                                                                <div className="p-3 border rounded text-left" style={{ minHeight: '50px', fontSize: '13px', color: '#333' }}>
                                                                    {item.PersonalNotes != null && item.PersonalNotes != '' ? item.PersonalNotes : 'Add nots here'}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Bottom Section for Seminars and Conferences */}
                                            <div className="col-12">
                                                {scheduleList.filter(item => item.ArrangementType != 'B2B Meeting').map(item => (
                                                    item.ArrangementType == 'Invitation Event' ? (
                                                        <div className="card mb-4 border p-0" style={{ borderRadius: '8px', backgroundColor: '#f8f9fa', border: '1px solid #ccc', boxShadow: 'none' }}>
                                                            <div className="card-body p-3 pb-3 text-left">
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                    <span className="badge rounded-pill" style={{ backgroundColor: '#9ea0a1', color: 'white', padding: '8px 16px', fontSize: '13px', fontWeight: '500' }}>
                                                                        <i className="fa fa-envelope mr-2"></i> Invitation
                                                                    </span>
                                                                </div>

                                                                <div className="mb-3 text-left">
                                                                    <p className="mb-3 text-dark font-weight-bold"><i className="fa fa-map-marker text-muted mr-2"></i> {item.Location || item.InvitationEventName}</p>
                                                                    <div className="d-flex flex-wrap text-muted" style={{ fontSize: '13px' }}>
                                                                        <span className="mr-3 mb-1" style={{ whiteSpace: 'nowrap' }}><i className="fa fa-calendar-o mr-2"></i> {item.Date && moment(item.Date).format("Do MMM YYYY")}</span>
                                                                        <span className="mb-1" style={{ whiteSpace: 'nowrap' }}><i className="fa fa-clock-o mr-2"></i> {item.StartTime && moment(item.StartTime).utc().format("HH:mm")} {item.EndTime && `- ${moment(item.EndTime).utc().format("HH:mm")}`}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="pt-3 mt-3" style={{ borderTop: '1px solid #dcdcdc' }}>
                                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                                        <label className="mb-0 text-left text-dark">Personal Notes</label>
                                                                        <button
                                                                            className="btn btn-aqua"
                                                                            title={item.PersonalNotes != null && item.PersonalNotes != '' ? "Update Note" : "Add Note"}
                                                                            onClick={() => this.setState({
                                                                                isOpenNote: true,
                                                                                ReferenceID: item.ReferenceID,
                                                                                ArrangementType: item.ArrangementType,
                                                                                PersonalNotes: item.PersonalNotes != null && item.PersonalNotes != '' ? item.PersonalNotes : ''
                                                                            })}
                                                                        >
                                                                            {item.PersonalNotes != null && item.PersonalNotes != '' ? "Edit Note" : "Add Note"}
                                                                        </button>
                                                                    </div>
                                                                    <div className="p-3 rounded text-left border">
                                                                        <p className="mb-0 text-dark font-italic" style={{ fontSize: '13px' }}>
                                                                            "{item.PersonalNotes != null && item.PersonalNotes != '' ? item.PersonalNotes : 'Add nots here.'}"
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="card mb-4 border p-0" style={{ borderRadius: '8px', backgroundColor: '#f8f9fa', border: '1px solid #ccc', boxShadow: 'none' }}>
                                                            <div className="card-body p-3 pb-3 text-left">
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                    <span className="badge rounded-pill" style={{ backgroundColor: '#4df0d4', color: '#000', padding: '8px 16px', fontSize: '13px', fontWeight: '500' }}>
                                                                        <i className="fa fa-graduation-cap mr-2"></i> Conference Session
                                                                    </span>
                                                                    <div className="text-muted d-flex align-items-center flex-wrap justify-content-end" style={{ fontSize: '13px' }}>
                                                                        <span className="px-md-3 px-1 mb-1" style={{ whiteSpace: 'nowrap' }}><i className="fa fa-calendar-o mr-1"></i> {item.Date && moment(item.Date).format("Do MMM YYYY")}</span>
                                                                        {item.StartTime && <span className="ml-md-3 ml-1 mb-1" style={{ whiteSpace: 'nowrap' }}><i className="fa fa-clock-o mr-1"></i> {moment(item.StartTime).utc().format("HH:mm")} {item.EndTime && `- ${moment(item.EndTime).utc().format("HH:mm")}`}</span>}
                                                                    </div>
                                                                </div>

                                                                <h6 className="mb-2 text-dark text-left" style={{ fontWeight: 'bold', lineHeight: '1.4', fontSize: '15px' }}>{item.SessionName}</h6>
                                                                {item.Speaker != null && item.Speaker != '' && <p className="text-muted mb-3 text-left" style={{ fontSize: '13px' }}>by {item.Speaker}</p>}

                                                                <div className="mb-0">
                                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                                        <label className="mb-0 text-left text-dark">Personal Notes</label>
                                                                        <button
                                                                            className="btn btn-aqua"
                                                                            title={item.PersonalNotes != null && item.PersonalNotes != '' ? "Update Note" : "Add Note"}
                                                                            onClick={() => this.setState({
                                                                                isOpenNote: true,
                                                                                ReferenceID: item.ReferenceID,
                                                                                ArrangementType: item.ArrangementType,
                                                                                PersonalNotes: item.PersonalNotes != null && item.PersonalNotes != '' ? item.PersonalNotes : ''
                                                                            })}
                                                                        >
                                                                            {item.PersonalNotes != null && item.PersonalNotes != '' ? "Edit Note" : "Add Note"}
                                                                        </button>
                                                                    </div>
                                                                    <div className="p-3 rounded text-left border">
                                                                        <p className="mb-0 text-dark font-italic" style={{ fontSize: '13px' }}>
                                                                            "{item.PersonalNotes != null && item.PersonalNotes != '' ? item.PersonalNotes : 'No notes added.'}"
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '400px' }}>
                        <div className="modal-content border-0" style={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', margin: 'auto', backgroundColor: '#fff', overflow: 'hidden' }}>
                            <div className="modal-header border-0 pb-0" style={{ padding: '24px 24px 10px 24px', backgroundColor: '#fff' }}>
                                <h5 className="modal-title" style={{ color: '#00665c', fontWeight: 'bold', fontSize: '18px' }}>Remove Interest</h5>
                                <button type="button" className="close" onClick={() => this.setState({ isOpen: false })} style={{ opacity: 1, backgroundColor: 'transparent', border: 'none', fontSize: '24px', outline: 'none', cursor: 'pointer', color: '#333' }}>&times;</button>
                            </div>
                            <div className="modal-body" style={{ padding: '16px 24px 24px 24px', backgroundColor: '#fff' }}>
                                <div className="d-flex align-items-center">
                                    <div style={{ fontSize: '16px', color: '#333', lineHeight: '1.5' }}>
                                        Do you really want to remove this exhibitor from interested list
                                    </div>
                                </div>
                            </div>
                            <div style={{ borderTop: '1px solid #eee', margin: '0 24px' }}></div>
                            <div className="modal-footer border-0 flex-column" style={{ padding: '24px', backgroundColor: '#fff' }}>
                                <button type="button" className="btn btn-aqua w-100 mb-3" onClick={(e) => this.removeMeeting(e)} >Yes</button>
                                <button type="button" className="btn btn-gray w-100 m-0" onClick={() => this.setState({ isOpen: false })}>No</button>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={isOpenNote} onRequestClose={() => this.setState({ isOpenNote: false })} size="lg">
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            <div class="modal-header p-2">
                                <h5 class="modal-title modal_title_text text-white">Personal Note</h5>
                            </div> <div class="modal-body">
                                {/* <div class="row">
                                    <div class="col-md-12">
                                        <p class="pop_label">{status == 1 ? "Do you really want to Approve this Meeting?" : "Do you really want to Reject this Meeting?"}</p>
                                    </div>
                                </div>
                                <hr /> */}
                                <div class="row">
                                    <div class="col-md-12">
                                        {/* <label>Personal Note</label> */}
                                        <textarea className="form-control" value={this.state.PersonalNotes} onChange={(e) => this.setState({ PersonalNotes: e.target.value })} />
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-aqua" onClick={(e) => this.SubmitPersonalNote()}>Submit</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpenNote: false })}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>)
    }
}


export default withRouter(connect(null, { getDrawerDetails_action, getRecommendation_action, fill_action, getVisitorDashboard_action, getCoordinatorDelegate_action, getVisitorRegistrationCredentials_action, getVisitorBadge_action, removeB2bMeeting_action, getCoordinatorDelegate_action, getRecommendationB2bDetails_action, addB2bPersonalNotes_action, getAllRecommendation_action, getDelegateDashboard_action, getDelegateRegistrationCredentials_action, getB2bScheduleList_action, updateB2bStatus_action })(MySchedule))